import { Button, Icon, Icons, Span } from "@ir/ui";

interface ListFilterButtonProps {
  onPress: () => void;
  activeCount?: number;
  className?: string;
  "aria-label"?: string;
}

export function ListFilterButton({
  onPress,
  activeCount = 0,
  className,
  "aria-label": ariaLabel = "Open filters",
}: Readonly<ListFilterButtonProps>) {
  const hasActive = activeCount > 0;

  return (
    <Button
      size="small"
      variant="outline"
      onPress={onPress}
      className={`list-filter-button${hasActive ? " list-filter-button--active" : ""}${className ? ` ${className}` : ""}`}
      aria-label={
        hasActive ? `${ariaLabel} (${activeCount} active)` : ariaLabel
      }
    >
      <Icon name={Icons.FilterLines} />
      {hasActive ? (
        <Span className="list-filter-button__badge" aria-hidden>
          {activeCount > 9 ? "9+" : activeCount}
        </Span>
      ) : null}
    </Button>
  );
}
